import React from 'react'
import tw from 'tailwind-styled-components'

export interface FieldProps {
  label: string
  children: React.ReactNode
  orientation?: 'horizontal' | 'vertical'
  required?: boolean
  bold?: boolean
}

const TwContainer = tw.div<{$orientation: 'horizontal' | 'vertical'}>`
  flex
  ${props => (props.$orientation === 'horizontal' ? 'flex-row' : 'flex-col')}
  gap-4
`

const TwLabel = tw.div<{$bold?: boolean}>`
  text-sm-regular
  text-secondary
  ${props => props.$bold && '!font-bold'}
`

const TwContent = tw.div`
  flex-1
`

export const SharedField = (props: FieldProps) => {
  const {
    label,
    bold,
    children,
    required = false,
    orientation = 'vertical'
  } = props

  return (
    <TwContainer $orientation={orientation}>
      <TwLabel $bold={bold}>
        {label}
        {required ? <span className="text-error ml-2">*</span> : ''}
      </TwLabel>
      <TwContent>{children}</TwContent>
    </TwContainer>
  )
}
